export enum SOCKET_EVENTS {
  RECONNECT = 'reconnect',
  RECONNECTING = 'reconnecting',
  RECONNECT_ATTEMPT = 'reconnect_attempt',
  RECONNECT_ERROR = 'reconnect_error',
  RECONNECT_FAILED = 'reconnect_failed',

  CONNECT = 'connect',
  CONNECT_ERROR = 'connect_error',
  CONNECT_TIMEOUT = 'connect_timeout',
  CONNECTION_READY = 'connection_ready',
  ERROR = 'error',
  DISCONNECT = 'disconnect',

  // Resync events
  GET_RESYNC_STATUS = 'get_resync_status',

  // May need to change this event name later
  SAVE_WIDGETS = 'save_widgets',
  SAVE_WIDGETS_FAILED = 'save_widgets_failed',
  SYNC_HISTORY = 'sync_history',
  SYNC_UNDO_HISTORY = 'sync_undo_history',
  SELECT_WIDGETS = 'select_widgets',
  DESELECT_WIDGETS = 'deselect_widgets',
  LOAD_FONTS = 'load_fonts',
  DISABLE_SHARE = 'disable_share',
  LOAD_COLOR_SWATCH = 'load_color_swatch',

  ENTER_EDITOR = 'enter_editor',
  LEAVE_EDITOR = 'leave_editor',
  INFOGRAPHICS_IN_EDITED = 'infographics_in_edited',
  LOAD_PAGE = 'load_page',
  LOAD_PAGE_ERROR = 'load_page_failed',
  LOAD_DESIGN = 'load_design',
  LOAD_DESIGN_ERROR = 'load_design_failed',

  PAGE_ADDED = 'page_added',
  PAGE_DELETED = 'page_deleted',
  PAGE_MOVED = 'page_moved',
  PAGE_LOADED = 'page_loaded',

  FETCH_PAGES_DATA_FOR_PM_THUMBNAILS = 'fetch_pages_data_for_pm_thumbnails',
  UPDATE_PM_THUMBNAILS = 'update_pm_thumbnails',

  SELECT_SPEAKER_NOTES = 'select_speaker_notes',
  DESELECT_SPEAKER_NOTES = 'deselect_speaker_notes',
  SAVE_SPEAKER_NOTES = 'save_speaker_notes',
}

export enum SOCKET_ERRORS {
  CONNECTION_ERROR = 'connection_error',
  RECONNECT_ERROR = 'reconnect_error',
  RESYNC_NEEDED_ERROR = 'resync_needed_error',
}
